import { c as _c } from "react/compiler-runtime";
import { NO_TRANSLATE_CLASS } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { DevFeatureToggleControl } from "@components/dev-features-dialog/dev-feature-toggle-control";
import { FEATURES, DEV_TOOLS, CREDENTIALS } from "@components/dev-features-dialog/features";
import { useDevTools } from "@components/dev-features-dialog/use-dev-tools";
import { useCredentials } from "@components/dev-features-dialog/use-credentials";
import { useFeatureToggle } from "@components/dev-features-dialog/use-feature-toggle";
import { useMemo } from "react";
import { useAppSelector } from "@store/store-helper";
import { appStateSelector } from "@store/app/app-selector";
import { DevToolControl } from "@components/dev-features-dialog/dev-tool-control";
import { CredentialsControl } from "@components/dev-features-dialog/credentials-control";
import { isToolToggleItem } from "@components/dev-features-dialog/features-utils";
import { devFeaturesStateSelector } from "@store/dev-features/dev-features-selector";
import { DevFeaturesTable } from "@components/dev-features-dialog/dev-features-table";
import { LocalStorageUtils } from "@utils/local-storage-utils";

/**
 * Panel displaying development features and tools tables.
 */
export function DevFeaturesPanel() {
  const $ = _c(19);
  const devTools = useDevTools();
  const credentials = useCredentials();
  const {
    createToggleHandler
  } = useFeatureToggle();
  const appState = useAppSelector(appStateSelector);
  const devFeaturesState = useAppSelector(devFeaturesStateSelector);
  let t0;
  if ($[0] !== appState || $[1] !== createToggleHandler) {
    t0 = FEATURES.map(feature => ({
      ...feature,
      isEnabled: appState[feature.appStateKey],
      onToggle: createToggleHandler(feature)
    }));
    $[0] = appState;
    $[1] = createToggleHandler;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const allFeatures = t0;
  let t1;
  if ($[3] !== devFeaturesState || $[4] !== devTools) {
    t1 = DEV_TOOLS.map(tool => {
      if (isToolToggleItem(tool) && tool.featureStateKey !== undefined) {
        return {
          ...tool,
          isEnabled: devFeaturesState[tool.featureStateKey],
          onToggle: isEnabled => {
            devTools[tool.action](isEnabled);
          }
        };
      }
      return {
        ...tool,
        onClick: devTools[tool.action]
      };
    });
    $[3] = devFeaturesState;
    $[4] = devTools;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const allTools = t1;
  let t2;
  if ($[6] !== credentials) {
    t2 = CREDENTIALS.map(credential => ({
      ...credential,
      username: LocalStorageUtils.getStringItem("analytics-api-username") ?? "",
      password: LocalStorageUtils.getStringItem("analytics-api-password") ?? "",
      onSave: credentials[credential.action]
    }));
    $[6] = credentials;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const allCredentials = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "100%",
      height: "100%",
      gap: 4
    };
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== allFeatures) {
    t4 = <DevFeaturesTable title="Features" items={allFeatures} renderControl={_temp} />;
    $[9] = allFeatures;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== allTools) {
    t5 = <DevFeaturesTable title="Dev Tools" items={allTools} renderControl={_temp2} />;
    $[11] = allTools;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== allCredentials) {
    t6 = <DevFeaturesTable title="Credentials" items={allCredentials} renderControl={_temp3} />;
    $[13] = allCredentials;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <Stack direction="column" className={NO_TRANSLATE_CLASS} sx={t3}>{t4}{t5}{t6}</Stack>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
function _temp3(item_1) {
  return <CredentialsControl item={item_1} />;
}
function _temp2(item_0) {
  return <DevToolControl item={item_0} />;
}
function _temp(item) {
  return <DevFeatureToggleControl item={item} />;
}